export default function IconError() {
    return (
        <svg
            width={220}
            height={120}
            viewBox="0 0 220 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M99.301 92.349C91.9726 92.349 84.8709 89.8094 79.206 85.163C73.541 80.5165 69.6634 74.0507 68.2337 66.8672C66.804 59.6837 67.9107 52.227 71.3653 45.7676C74.8199 39.3083 80.4087 34.2459 87.1792 31.443C93.9498 28.6402 101.483 28.2703 108.496 30.3964C115.509 32.5225 121.567 37.0131 125.639 43.1029C129.71 49.1928 131.543 56.5052 130.825 63.7941C130.106 71.0831 126.881 77.8976 121.699 83.0766C118.765 86.0255 115.274 88.3635 111.43 89.9551C107.585 91.5467 103.462 92.3604 99.301 92.349ZM99.301 29.2765C81.9691 29.2765 67.8685 43.369 67.8685 60.6911C67.8685 78.0131 81.9691 92.1056 99.301 92.1056C116.633 92.1056 130.734 78.0131 130.734 60.6911C130.734 43.369 116.633 29.2765 99.301 29.2765Z"
                fill="#CCCCCC"
            />
            <path
                d="M111.062 97.0967V65.2031H87.3113V97.0967H111.062Z"
                fill="#2F2E41"
            />
            <path
                d="M115.144 64.2285H83.2324V76.8886H115.144V64.2285Z"
                fill="#7B67FB"
            />
            <path
                d="M115.144 78.3496H83.2324V91.0097H115.144V78.3496Z"
                fill="#7B67FB"
            />
            <path
                d="M115.144 92.4707H83.2324V105.131H115.144V92.4707Z"
                fill="#7B67FB"
            />
            <path
                d="M115.144 69.5977H83.2324V71.5454H115.144V69.5977Z"
                fill="#DBDBDB"
            />
            <path
                d="M115.144 83.7188H83.2324V85.6665H115.144V83.7188Z"
                fill="#DBDBDB"
            />
            <path
                d="M115.144 97.8379H83.2324V99.7856H115.144V97.8379Z"
                fill="#DBDBDB"
            />
            <path
                d="M108.932 66.785C109.336 66.785 109.663 66.458 109.663 66.0546C109.663 65.6512 109.336 65.3242 108.932 65.3242C108.528 65.3242 108.201 65.6512 108.201 66.0546C108.201 66.458 108.528 66.785 108.932 66.785Z"
                fill="#DBDBDB"
            />
            <path
                d="M111.491 66.785C111.894 66.785 112.221 66.458 112.221 66.0546C112.221 65.6512 111.894 65.3242 111.491 65.3242C111.087 65.3242 110.76 65.6512 110.76 66.0546C110.76 66.458 111.087 66.785 111.491 66.785Z"
                fill="#DBDBDB"
            />
            <path
                d="M114.047 66.785C114.451 66.785 114.778 66.458 114.778 66.0546C114.778 65.6512 114.451 65.3242 114.047 65.3242C113.644 65.3242 113.316 65.6512 113.316 66.0546C113.316 66.458 113.644 66.785 114.047 66.785Z"
                fill="#DBDBDB"
            />
            <path
                d="M108.932 80.6619C109.336 80.6619 109.663 80.3349 109.663 79.9316C109.663 79.5282 109.336 79.2012 108.932 79.2012C108.528 79.2012 108.201 79.5282 108.201 79.9316C108.201 80.3349 108.528 80.6619 108.932 80.6619Z"
                fill="#DBDBDB"
            />
            <path
                d="M111.491 80.6619C111.894 80.6619 112.221 80.3349 112.221 79.9316C112.221 79.5282 111.894 79.2012 111.491 79.2012C111.087 79.2012 110.76 79.5282 110.76 79.9316C110.76 80.3349 111.087 80.6619 111.491 80.6619Z"
                fill="#DBDBDB"
            />
            <path
                d="M114.047 80.6619C114.451 80.6619 114.778 80.3349 114.778 79.9316C114.778 79.5282 114.451 79.2012 114.047 79.2012C113.644 79.2012 113.316 79.5282 113.316 79.9316C113.316 80.3349 113.644 80.6619 114.047 80.6619Z"
                fill="#DBDBDB"
            />
            <path
                d="M108.932 94.5409C109.336 94.5409 109.663 94.2139 109.663 93.8105C109.663 93.4071 109.336 93.0801 108.932 93.0801C108.528 93.0801 108.201 93.4071 108.201 93.8105C108.201 94.2139 108.528 94.5409 108.932 94.5409Z"
                fill="#DBDBDB"
            />
            <path
                d="M111.491 94.5409C111.894 94.5409 112.221 94.2139 112.221 93.8105C112.221 93.4071 111.894 93.0801 111.491 93.0801C111.087 93.0801 110.76 93.4071 110.76 93.8105C110.76 94.2139 111.087 94.5409 111.491 94.5409Z"
                fill="#DBDBDB"
            />
            <path
                d="M114.047 94.5409C114.451 94.5409 114.778 94.2139 114.778 93.8105C114.778 93.4071 114.451 93.0801 114.047 93.0801C113.644 93.0801 113.316 93.4071 113.316 93.8105C113.316 94.2139 113.644 94.5409 114.047 94.5409Z"
                fill="#DBDBDB"
            />
            <path
                d="M153.267 105.01H45.1074V105.253H153.267V105.01Z"
                fill="#3F3D56"
            />
            <path
                d="M74.5699 51.7216V74.3626C74.5698 74.8363 74.3815 75.2906 74.0464 75.6255C73.7113 75.9604 73.2568 76.1486 72.7828 76.1487H63.9793C63.5052 76.1488 63.0505 75.9607 62.7152 75.6257C62.38 75.2908 62.1915 74.8364 62.1914 74.3626V51.7216C62.1915 51.2478 62.38 50.7935 62.7152 50.4586C63.0505 50.1236 63.5052 49.9355 63.9793 49.9355H65.0472C64.9947 50.0644 64.9748 50.2042 64.9891 50.3426C65.0033 50.481 65.0514 50.6138 65.1291 50.7293C65.2067 50.8447 65.3115 50.9394 65.4344 51.0049C65.5572 51.0704 65.6942 51.1047 65.8334 51.1049H70.8527C70.9919 51.1047 71.1289 51.0704 71.2517 51.0049C71.3745 50.9394 71.4794 50.8447 71.557 50.7293C71.6347 50.6138 71.6827 50.481 71.697 50.3426C71.7113 50.2042 71.6913 50.0644 71.6389 49.9355H72.7828C73.2568 49.9356 73.7113 50.1238 74.0464 50.4588C74.3815 50.7937 74.5698 51.248 74.5699 51.7216Z"
                fill="#E6E6E6"
            />
            <path
                d="M73.983 54.2598H62.7773V69.8414H73.983V54.2598Z"
                fill="white"
            />
            <path
                d="M70.4315 64.9746H65.959V65.23H70.4315V64.9746Z"
                fill="#E6E6E6"
            />
            <path
                d="M72.8755 65.9121H65.9551V66.1675H72.8755V65.9121Z"
                fill="#9B9BAA"
            />
            <path
                d="M71.386 66.7949H65.9551V67.0504H71.386V66.7949Z"
                fill="#E6E6E6"
            />
            <path
                d="M69.1497 67.6797H65.9551V67.9351H69.1497V67.6797Z"
                fill="#E6E6E6"
            />
            <path
                d="M70.747 68.5625H65.9551V68.8179H70.747V68.5625Z"
                fill="#E6E6E6"
            />
            <path
                d="M64.4408 64.9004H63.9297V65.4112H64.4408V64.9004Z"
                fill="#E6E6E6"
            />
            <path
                d="M64.4408 65.7832H63.9297V66.2941H64.4408V65.7832Z"
                fill="#9B9BAA"
            />
            <path
                d="M64.4408 66.668H63.9297V67.1788H64.4408V66.668Z"
                fill="#E6E6E6"
            />
            <path
                d="M64.4408 67.5508H63.9297V68.0616H64.4408V67.5508Z"
                fill="#E6E6E6"
            />
            <path
                d="M64.4408 68.4355H63.9297V68.9464H64.4408V68.4355Z"
                fill="#E6E6E6"
            />
            <path
                d="M70.6548 56.207H66.1484V60.7108H70.6548V56.207Z"
                fill="#E6E6E6"
            />
            <path
                d="M114.168 18.7422H84.2188V37.9118H114.168V18.7422Z"
                fill="#E6E6E6"
            />
            <path
                d="M111.307 24.1055H86.4766V33.4831H111.307V24.1055Z"
                fill="white"
            />
            <path
                d="M96.9613 25.7285H91.002V26.0689H96.9613V25.7285Z"
                fill="#E6E6E6"
            />
            <path
                d="M100.217 26.9785H90.9961V27.3189H100.217V26.9785Z"
                fill="#9B9BAA"
            />
            <path
                d="M98.2324 28.1562H90.9961V28.4966H98.2324V28.1562Z"
                fill="#E6E6E6"
            />
            <path
                d="M95.2528 29.334H90.9961V29.6743H95.2528V29.334Z"
                fill="#E6E6E6"
            />
            <path
                d="M97.3811 30.5117H90.9961V30.8521H97.3811V30.5117Z"
                fill="#E6E6E6"
            />
            <path
                d="M88.9799 25.6309H88.2988V26.3115H88.9799V25.6309Z"
                fill="#E6E6E6"
            />
            <path
                d="M88.9799 26.8086H88.2988V27.4893H88.9799V26.8086Z"
                fill="#9B9BAA"
            />
            <path
                d="M88.9799 27.9863H88.2988V28.667H88.9799V27.9863Z"
                fill="#E6E6E6"
            />
            <path
                d="M88.9799 29.1641H88.2988V29.8447H88.9799V29.1641Z"
                fill="#E6E6E6"
            />
            <path
                d="M88.9799 30.3398H88.2988V31.0205H88.9799V30.3398Z"
                fill="#E6E6E6"
            />
            <path
                d="M110.089 25.2793H103.992V31.373H110.089V25.2793Z"
                fill="#E6E6E6"
            />
            <path
                d="M114.156 18.7246H84.207V19.9962H114.156V18.7246Z"
                fill="#9B9BAA"
            />
            <path
                d="M85.1519 19.6297C85.2929 19.6297 85.4073 19.5154 85.4073 19.3744C85.4073 19.2334 85.2929 19.1191 85.1519 19.1191C85.0108 19.1191 84.8965 19.2334 84.8965 19.3744C84.8965 19.5154 85.0108 19.6297 85.1519 19.6297Z"
                fill="white"
            />
            <path
                d="M86.0484 19.6297C86.1894 19.6297 86.3038 19.5154 86.3038 19.3744C86.3038 19.2334 86.1894 19.1191 86.0484 19.1191C85.9073 19.1191 85.793 19.2334 85.793 19.3744C85.793 19.5154 85.9073 19.6297 86.0484 19.6297Z"
                fill="white"
            />
            <path
                d="M86.9429 19.6297C87.084 19.6297 87.1983 19.5154 87.1983 19.3744C87.1983 19.2334 87.084 19.1191 86.9429 19.1191C86.8018 19.1191 86.6875 19.2334 86.6875 19.3744C86.6875 19.5154 86.8018 19.6297 86.9429 19.6297Z"
                fill="white"
            />
            <path
                d="M134.224 54.6113H126.916V58.385H134.224V54.6113Z"
                fill="#E6E6E6"
            />
            <path
                d="M134.224 68.125H126.916V71.8987H134.224V68.125Z"
                fill="#E6E6E6"
            />
            <path
                d="M130.571 69.3411C133.934 69.3411 136.661 66.6161 136.661 63.2545C136.661 59.893 133.934 57.168 130.571 57.168C127.207 57.168 124.48 59.893 124.48 63.2545C124.48 66.6161 127.207 69.3411 130.571 69.3411Z"
                fill="#E6E6E6"
            />
            <path
                d="M130.571 68.0029C133.194 68.0029 135.321 65.8773 135.321 63.2553C135.321 60.6334 133.194 58.5078 130.571 58.5078C127.947 58.5078 125.82 60.6334 125.82 63.2553C125.82 65.8773 127.947 68.0029 130.571 68.0029Z"
                fill="white"
            />
            <path
                d="M132.698 61.9551H129.014V62.1655H132.698V61.9551Z"
                fill="#E2E2E2"
            />
            <path
                d="M134.71 62.7266H129.01V62.937H134.71V62.7266Z"
                fill="#9B9BAA"
            />
            <path
                d="M133.483 63.4551H129.01V63.6655H133.483V63.4551Z"
                fill="#E2E2E2"
            />
            <path
                d="M131.641 64.1816H129.01V64.392H131.641V64.1816Z"
                fill="#E2E2E2"
            />
            <path
                d="M132.957 64.9102H129.01V65.1206H132.957V64.9102Z"
                fill="#E2E2E2"
            />
            <path
                d="M127.765 61.8926H127.344V62.3134H127.765V61.8926Z"
                fill="#E2E2E2"
            />
            <path
                d="M127.765 62.6211H127.344V63.0419H127.765V62.6211Z"
                fill="#9B9BAA"
            />
            <path
                d="M127.765 63.3496H127.344V63.7704H127.765V63.3496Z"
                fill="#E2E2E2"
            />
            <path
                d="M127.765 64.0781H127.344V64.4989H127.765V64.0781Z"
                fill="#E2E2E2"
            />
            <path
                d="M127.765 64.8047H127.344V65.2255H127.765V64.8047Z"
                fill="#E2E2E2"
            />
            <path
                d="M139.22 50.3195H173.016C173.343 50.3177 173.663 50.2312 173.947 50.0682C174.23 49.9053 174.467 49.6715 174.634 49.3896C174.801 49.1077 174.892 48.7873 174.899 48.4595C174.906 48.1317 174.828 47.8077 174.673 47.5189L157.783 16.0242C157.622 15.7222 157.381 15.47 157.088 15.2941C156.795 15.1182 156.459 15.0254 156.118 15.0254C155.776 15.0254 155.441 15.1182 155.148 15.2941C154.854 15.47 154.614 15.7222 154.452 16.0242L137.554 47.5189C137.399 47.8083 137.321 48.1331 137.329 48.4616C137.336 48.79 137.428 49.111 137.596 49.3932C137.764 49.6753 138.001 49.9089 138.286 50.0713C138.571 50.2337 138.892 50.3192 139.22 50.3195ZM158.268 44.5645H153.967V40.2503H158.268V44.5645ZM158.268 37.3727H153.967V28.7423H158.268V37.3727Z"
                fill="#F9C153"
            />
        </svg>
    );
}
